import React, { Component } from 'react';
import {
        CardNumberElement,
        CardCVCElement,
        CardExpiryElement,
        injectStripe,
        PaymentRequestButtonElement,
        PostalCodeElement
        } from 'react-stripe-elements';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import Responsive from 'react-responsive';
import Api from '../../utils/api';

const valueArr = [20, 40, 50, 60, 80, 150];

class GiftPayment extends Component {
	constructor(props) {
		super(props);

        this.idempotencyKey = Api.getUUID();

        const paymentRequest = this.props.stripe.paymentRequest({
            country: 'US',
            currency: 'usd',
            total: {
                label: 'Gate Fee',
                amount: 1000
            },
        });

        paymentRequest.on('token', ({complete, token, ...data}) => {
            this.handlePayment(token);
            complete('success');
        });
        paymentRequest.canMakePayment().then((result) => this.setState({ showPaymentRequestButton: !!result }));

		this.state = {
            country: '',
            region: '',
            fnameShipping: '',
            lnameShipping: '',
            addressShipping: '',
            addressShippingTwo: '',
            cityShipping: '',
            zipShipping: '',
            name: '',
            addressOne: '',
            addressTwo: '',
            city: '',
            zip: '',
            paymentRequest: paymentRequest,
            disableButton: false,
            errorMessageShow: false,
			errorMessage: ""
		};

	}

    handleChangeAdddressInput = (e) => {
        e.persist();
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value });
    }

    selectCountry(val) {
      this.setState({ country: val });
    }

    selectRegion(val) {
        this.setState({ region: val });
    }




    handleSubmit = (e) => {
        e.persist();
        e.preventDefault();
        this.setState({ disableButton: true });
        this.props.stripe.createToken({
            name: e.target.name.value,
            address_line1: e.target.addressOne.value,
            address_line2: e.target.addressTwo.value,
            address_city: e.target.city.value,
            address_country: this.state.country,
            address_state: this.state.region
        })
        .then(({token}) => {
            this.handlePayment(token);
        })
        .catch((err) => {
            //Creating token
            console.log(err);
            this.setState( {errorInPayment: true, disableButton: false, errorMessageShow: true} );
        });

    }

    handlePayment = (token) => {
		const price = this.props.price;
        fetch('/api/gift-card', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				"stripeToken": token.id,
				"amount": price,
				"idempotencyKey": this.idempotencyKey
			})
		})
		.then((response) =>
			{
				if (response.headers.get('x-helloavaapp-error') && response.headers.get('x-helloavaapp-error').includes("Keys for idempotent requests can only be used with the same parameters")) {
					//Duplicate payment
					this.setState({ errorMessageShow: true, errorMessage: "You have already submitted a payment that has been processed or is being processed.", disableButton: false });
					throw new Error("You have already submitted a payment that has been processed or is being processed.") 
				} else if (response.headers.get('x-helloavaapp-error') && response.headers.get('x-helloavaapp-error').includes("security code"))  {
                    //Incorrect security code.
                    this.idempotencyKey = Api.getUUID();
                    this.setState({ errorMessageShow: true, errorMessage: "The security code entered was incorrect. Please try again.", disableButton: false });
                    throw new Error("The security code entered was incorrect. Please try again.");
                } else if (response.headers.get('x-helloavaapp-error') && response.headers.get('x-helloavaapp-error').includes("zip code")) {
                    //Incorrect zip code.
					this.idempotencyKey = Api.getUUID();
                    this.setState({ errorMessageShow: true, errorMessage: "The zip code entered was incorrect. Please try again.", disableButton: false });
                    throw new Error("The zip code entered was incorrect. Please try again.");
                } else if ((!response.headers.get('x-helloavaapp-error') && (response.status >= 400))) {
                    //Other errors
					this.idempotencyKey = Api.getUUID();
                    this.setState({ errorMessageShow: true, errorMessage: "Payment failed. Please try again.", disableButton: false });
                    throw new Error("Payment failed. Please try again.");
                } else {
					this.setState({ userPaid: true, errorMessageShow: false }, function() {
                        this.props.addGiftUsersToZapierTriggerHook(this.state.toFirstName, this.state.toLastName, this.state.fromName, this.state.toEmail, this.state.fromEmail, this.state.message, valueArr[this.state.value]);
                    });
					document.getElementById("PaymentRequestButton").setAttribute("disabled", "disabled");
             		
				}

				response.json();
			})
		.catch((err) => {
			//Error in payment/server issue
			this.setState( {errorInPayment: true } );
		});
    }

    renderErrorMessage = () => {
        if (this.state.errorMessageShow) return <div className="user-paid error-confirm">{ this.state.errorMessage }</div>;
        else return null;
    }

	render() {
		return (
    			<div className="gift-credit-card">
    				<form id="checkout-form" onSubmit={this.handleSubmit}>
                        <div className="block-content checkout">
                            <div className="credit-card-header">
                                <h3>Payment method</h3>
                            </div>

                            <div className="credit-card-logos">
                                <div className="credit-card-logo"><img alt="Visa" src="/images/gate/visa.png" /></div>
                                <div className="credit-card-logo"><img alt="Mastercard" src="/images/gate/mastercard.png" /></div>
                                <div className="credit-card-logo"><img alt="Discover" src="/images/gate/discover.png" /></div>
                                <div className="credit-card-logo"><img alt="American Express" src="/images/gate/amex.png" /></div>
                                <div className="credit-card-logo"><img alt="JCB" src="/images/gate/jcb.png" /></div>
                                <div className="credit-card-logo"><img alt="Diner's" src="/images/gate/diners.png" /></div>
                            </div>

                            <label>
                                <div className="card-label number"><h4>Credit Card Number</h4></div>
                                <Responsive minWidth={ 901 }>
                                    <CardNumberElement
                                        style={{
                                            base: {
                                                color: '#272d67',
                                                fontSize: '18px',
                                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                background: '#fff'
                                            }
                                        }}
                                        placeholder="" 
                                        name="Credit Card Number" 
                                    />
                                </Responsive>
                                <Responsive maxWidth={ 900 }>
                                    <CardNumberElement
                                        style={{
                                            base: {
                                                color: '#272d67',
                                                fontSize: '12px',
                                                fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                background: '#fff'
                                            }
                                        }}
                                        placeholder="" 
                                        name="Credit Card Number" 
                                    />
                                </Responsive>
                            </label>

                            <label>
                                <div className="card-label name"><h4>Name</h4></div>
                                <input onChange={ this.handleChangeAdddressInput } name="name" value={ this.state.name } type="text" placeholder="" required />
                            </label>

                            <div className="security-expiration">
                                <label>
                                    <div className="card-label security"><h4>Security Code</h4></div>
                                    <Responsive minWidth={ 901 }>
                                        <CardCVCElement 
                                            placeholder="" 
                                            style={{
                                                base: {
                                                    color: '#272d67',
                                                    fontSize: '18px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }}
                                        />
                                    </Responsive>
                                    <Responsive maxWidth={ 900 }>
                                        <CardCVCElement 
                                            placeholder="" 
                                            style={{
                                                base: {
                                                    color: '#272d67',
                                                    fontSize: '12px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }}
                                        />
                                    </Responsive>
                                </label>
                                <label>
                                    <div className="card-label expiration"><h4>Expiration (MM/YY)</h4></div>
                                    <Responsive minWidth={ 901 }>
                                        <CardExpiryElement 
                                            placeholder="" 
                                            style={{
                                            base: {
                                                    color: '#272d67',
                                                    fontSize: '18px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }}
                                        />
                                    </Responsive>
                                    <Responsive maxWidth={ 900 }>
                                        <CardExpiryElement 
                                            placeholder="" 
                                            style={{
                                            base: {
                                                    color: '#272d67',
                                                    fontSize: '12px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }}
                                        />
                                    </Responsive>
                                </label>
                            </div>

                            <div className="credit-card-header">
                                <h3>Billing info</h3>
                            </div>

                            <label>
                                <div className="card-label addressOne"><h4>Address Line 1 (Street)</h4></div>
                                <input onChange={ this.handleChangeAdddressInput }  name="addressOne" value={ this.state.addressOne } type="text" placeholder="" required />
                            </label>

                            <label>
                                <div className="card-label addressTwo"><h4>Address Line 2 (Apt Number)</h4></div>
                                <input onChange={ this.handleChangeAdddressInput }  name="addressTwo" value={ this.state.addressTwo }type="text" placeholder="" />
                            </label>

                            <label>
                                <div className="card-label city"><h4>City</h4></div>
                                <input onChange={ this.handleChangeAdddressInput }  name="city" value={ this.state.city } type="text" placeholder="" required />
                            </label>

                            <div className="country-state-zip">
                                <label>
                                    <div className="card-label country"><h4>Country</h4></div>
                                    <CountryDropdown
                                        value={this.state.country}
                                        defaultOptionLabel="Select Country"
                                        onChange={(val) => this.selectCountry(val)}
                                        whitelist={["US", "CA", "GB"]}
                                    />
                                </label>
                                <label>
                                    <div className="card-label state"><h4>State</h4></div>
                                    <RegionDropdown
                                        country={this.state.country}
                                        value={this.state.region}
                                        defaultOptionLabel={this.state.country === "United States" ? "State" : "Province"}
                                        onChange={(val) => this.selectRegion(val)}
                                    />
                                </label>

                                <label>
                                    <div className="card-label zip"><h4>Postal Code</h4></div>
                                    <Responsive minWidth={ 901 }>
                                        <PostalCodeElement 
                                            placeholder=""
                                            value={ this.state.zip } 
                                            name="zip"
                                            style={{
                                            base: {
                                                    color: '#272d67',
                                                    fontSize: '18px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }} 
                                        />
                                    </Responsive>
                                    <Responsive maxWidth={ 900 }>
                                        <PostalCodeElement 
                                            placeholder=""
                                            value={ this.state.zip } 
                                            name="zip"
                                            style={{
                                            base: {
                                                    color: '#272d67',
                                                    fontSize: '12px',
                                                    fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
                                                    background: '#fff'
                                                }
                                            }} 
                                        />
                                    </Responsive>
                                </label>

                            </div>

                            
                            <div className="payment-buttons">
                                <div className="complete-purchase-button">
                                    <button style={{ marginRight: '1em' }} onClick={ this.props.handleStepsBack }>Back</button>
                                    <button id="PaymentRequestButton" disabled={ this.state.disableButton }>Submit</button>
                                </div>
                                {
                                    this.state.showPaymentRequestButton &&
                                    <div className="apple-pay-section">
                                        <div className="or">or</div>
                                            <PaymentRequestButtonElement
                                                paymentRequest={ this.state.paymentRequest }
                                                className="payment-request-button"
                                                style={{
                                                    paymentRequestButton: {
                                                        width: '100px',
                                                        height: '30px',
                                                        borderRadius: '10px'
                                                    },
                                                }}
                                            />
                                    </div>
                                }
                            </div>
                        </div>
                    </form>
                    { this.renderErrorMessage() }
    			</div>
		);
	}
}

export default injectStripe(GiftPayment);



// WEBPACK FOOTER //
// ./src/views/gift/GiftPayment.js